package com.wintermar.inspection.feature.presentation.inspection.answer.widget.incomplete

import androidx.compose.runtime.Composable
import com.wintermar.inspection.core.ui.component.modal.ModalDialog
import com.wintermar.inspection.core.ui.component.modal.util.ModalActionModel
import com.wintermar.inspection.feature.domain.model.answer.SummaryAnswerModel

@Composable
actual fun IncompleteModal(
    show: Boolean,
    unAnswerList: List<SummaryAnswerModel>,
    needDocumentList: List<SummaryAnswerModel>,
    action: ModalActionModel,
    onDismiss: () -> Unit
) {
    ModalDialog(
        show = show,
        action = action.copy(
            widthButtonBasedOnText = true,
            withBackgroundHeader = true
        ),
        onDismiss = onDismiss,
        contentHeader = {
            IncompleteHeader(unAnswerList.size + needDocumentList.size)
        }
    ) {
        Incomplete(
            withHeader = false,
            unAnswerList = unAnswerList,
            needDocumentList = needDocumentList,
        )
    }
}
